export default __webpack_public_path__ + "static/logo2-72df3762bf875f61c8000416c81d2393.png";